import React from 'react'
import { Steper } from '../../styles.style'

const Breadcrumb = ({ step }) => {
	return (
		<Steper className={step === 6 ? 'hide' : null}>
			<ul>
				{(() => {
					const items = []
					for (let i = 0; i < 6; i++) {
						items.push(
							<li
								key={i}
								className={
									(step === i + 1 ? 'active' : '') +
									(step > i + 1 ? 'before' : '')
								}
							/>
						)
					}
					return items
				})()}
			</ul>
		</Steper>
	)
}

export default Breadcrumb
